const message = {
  INVALID_NOTE: 'Note must have a valid format',
  INVALID_NOTE_LENGTH: (numberOfChars = 255) =>
    `Note is too long (maximal length: ${numberOfChars} characters)`,
};

export { message };
